// extracted by mini-css-extract-plugin
export default {"wrapper":"u6-z"};